import { SKTTextField } from "./SKTTextField";
import { SKTFavoriteSelect } from "./SKTFavoriteSelect";
import { SKTAutocompleteTextField } from "./SKTAutocompleteTextField";
import { Fragment } from "react";
import { SKTToggle } from "./SKTToggle";
import { SKTBaseComponent } from "./SKTBaseComponent";

export const SKTAddressField = ({
  showFavorite,
  label,
  data,
  prefix,
  options,
  corporate,
  hideEmail,
  includeSE,
  showFlags,
}) => {
  const prefixed = (key) => `${prefix}${key}`;

  return (
    <Fragment>
      <SKTToggle when={label}>
        <SKTBaseComponent id={prefixed("AddressHeader")} label={label}>
          <SKTToggle when={showFavorite}>
            <SKTFavoriteSelect data={data} prefix={prefix} />
          </SKTToggle>
        </SKTBaseComponent>
      </SKTToggle>
      <SKTTextField
        label="Nimi"
        data={data}
        id={prefixed("Name")}
        placeholder="Antti Asiakas"
      />
      <SKTToggle when={corporate}>
        <SKTTextField
          label="Yritys"
          data={data}
          id={prefixed("Name2")}
          placeholder=""
          tooltip="Mikäli kyseessä on yritysosoite, lisää tähän yrityksen nimi (esim. Yritys Oy). Muussa tapauksessa jätä tämä kenttä tyhjäksi"
        />
      </SKTToggle>
      <SKTTextField
        label="Katuosoite"
        data={data}
        id={prefixed("Addr1")}
        placeholder="Kauppakatu 1"
      />

      <SKTAutocompleteTextField
        data={data}
        id={prefixed("ZIP")}
        label="Postinumero"
        placeholder="00100 HELSINKI"
        options={options}
        includeSE={includeSE}
        showFlags={showFlags}
      />

      <SKTTextField
        label="Puhelinnumero"
        data={data}
        id={prefixed("Phone")}
        placeholder="049 876 5432"
      />
      <SKTToggle when={!hideEmail}>
        <SKTTextField
          label="Sähköpostiosoite"
          data={data}
          id={prefixed("Email")}
          placeholder="antti.asiakas@yritys.fi"
        />
      </SKTToggle>
    </Fragment>
  );
};
